import * as React from 'react';

import axios from 'axios';
import cookie from 'cookie_js';
import $ from 'jquery';
import * as Raven from 'raven-js';
import { Col, Row } from 'react-bootstrap';
// eslint-disable-next-line import/named
import { RouteComponentProps } from 'react-router';

import { Track } from '../../analytics';
import * as Api from '../../Api';
import * as BasketControl from '../../BasketControl';
import { BASKET_OFFSET, MIN_BASKET_HEIGHT } from '../../constants/Constants';
import * as Routes from '../../Routes';
import { storage } from '../../services/storageServices';
import { Utilities } from '../../Utilities';
import Basket from '../Basket';
import BottomBar from '../BottomBar';
import ClosedAlert from '../ClosedAlert';
import LoadingPanel from '../LoadingPanel';
import LocationHeader from '../LocationHeader';
import { MainLayout } from '../MainLayout/MainLayout';
import Menu from '../Menu';
import PermissionConsentDialog from '../PermissionConsentDialog';
import StatusDisplay from '../StatusDisplay';
import Toast from '../Toast';
import { DispatchProps, loadStatus, StateProps } from './index';

const isEmpty = require('lodash/isEmpty');

interface ParentProps {
  parentComponent: JSX.Element;
}

type RouteProps = RouteComponentProps<
  {
    vrid: number;
    type?: 'collection' | 'delivery';
    id?: number;
    concessionStoreId?: number;
  },
  {}
>;

type Props = StateProps &
  DispatchProps &
  RouteProps &
  ParentProps & { params: { concessionStoreId: number } };

interface State {
  menuLoadState: loadStatus;
  loadRestaurantListStatus: loadStatus;
  loadRestaurantDetailStatus: loadStatus;
  ShowModal: boolean;
}

class Restaurant extends React.Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context);

    this.state = {
      ShowModal: false,
      menuLoadState: 'NOT_LOADED',
      loadRestaurantDetailStatus: this.isRestaurantLoadingInitiated(
        props.Restaurant.status,
      )
        ? 'LOADING'
        : 'NOT_LOADED',
      loadRestaurantListStatus: this.isRestaurantLoadingInitiated(
        props.Restaurants.status,
      )
        ? 'LOADING'
        : 'NOT_LOADED',
    };
  }

  public isRestaurantLoadingInitiated(status) {
    return ['pending', 'success'].includes(status);
  }

  public componentDidMount(): void {
    const {
      menu,
      Restaurant: restaurant,
      Restaurants: restaurants,
    } = this.props;
    document.documentElement.scrollTop = document.body.scrollTop = this.props.MenuScroll;

    //Revert options state to initial
    this.props.SetOptionsState([], [[]], 0, []);
    this.props.SetRestaurantUrl();
    window.addEventListener('scroll', this.resizeBasket);
    this.resizeBasket();

    if (restaurant.status === 'success') {
      this.setState({ loadRestaurantDetailStatus: 'LOADED' });
    }

    if (restaurants.status === 'success') {
      this.setState({ loadRestaurantListStatus: 'LOADED' });
    }

    if (menu) {
      this.setState({ menuLoadState: 'LOADED' });
    }
  }

  public componentDidUpdate(newProps: Props): void {
    const {
      flagTargetedLoadingEnabled,
      getMenuByUrl,
      menu,
      MenuUrl,
      params,
      Restaurant: restaurant,
      Restaurants: restaurants,
    } = newProps;
    if (
      flagTargetedLoadingEnabled &&
      this.state.loadRestaurantDetailStatus === 'NOT_LOADED'
    ) {
      this.props.getRestaurantData(params.vrid, params.type, params.id);
      this.setState({ loadRestaurantDetailStatus: 'LOADING' });
    }

    if (
      restaurant.status === 'success' &&
      this.state.loadRestaurantDetailStatus !== 'LOADED'
    ) {
      this.setState({ loadRestaurantDetailStatus: 'LOADED' });
    }

    if (
      !flagTargetedLoadingEnabled &&
      (this.state.loadRestaurantListStatus === 'NOT_LOADED' ||
        !this.isRestaurantLoadingInitiated(restaurants.status))
    ) {
      this.props.FindInitialRestaurant();
      this.setState({ loadRestaurantListStatus: 'LOADING' });
    }

    if (
      restaurants.status === 'success' &&
      this.state.loadRestaurantListStatus !== 'LOADED'
    ) {
      this.setState({ loadRestaurantListStatus: 'LOADED' });
    }

    if (!menu && MenuUrl && this.state.menuLoadState === 'NOT_LOADED') {
      getMenuByUrl(MenuUrl);
      this.setState({ menuLoadState: 'LOADING' });
    }

    if (
      flagTargetedLoadingEnabled &&
      !menu &&
      restaurant.status === 'success' &&
      this.state.menuLoadState === 'NOT_LOADED'
    ) {
      getMenuByUrl(restaurant.data.MenuUrl);
      this.setState({ menuLoadState: 'LOADING' });
    }

    if (!!menu && this.state.menuLoadState !== 'LOADED') {
      this.setState({ menuLoadState: 'LOADED' });
    }

    this.resizeBasket();
  }

  public componentWillUnmount() {
    const top = window.pageYOffset;

    if (top) {
      this.props.SetMenuScroll(top);
    }

    window.removeEventListener('scroll', this.resizeBasket);
  }

  private toggleModal = () => {
    this.setState((prevState) => ({
      ShowModal: !prevState.ShowModal,
    }));
  };

  // TODO:DN should be in StickyTopBasketWrapper component
  private resizeBasket = () => {
    const basket = document.getElementsByClassName(
      'basket-item-list',
    )[0] as HTMLElement;

    const basketHolder = document.getElementsByClassName(
      'menu__basket',
    )[0] as HTMLElement;

    if (basket && basketHolder) {
      //Offset to calculate basket height
      let offset = 0;

      //Offset for scroll height
      const scrollOffset = $(basketHolder).offset().top;

      if (window.scrollY <= scrollOffset) {
        //If basket is not in "fixed-top" mode offset accounts for the amount the page is scrolled down and the sum of the heights of the basket header and checkout button
        offset = BASKET_OFFSET + (scrollOffset - window.scrollY);
      } else {
        //If basket is in "fixed-top" mode offset is the top offset to account for headers (data-offset) and the sum of the heights of the basket header and checkout button
        offset = BASKET_OFFSET + this.props.Offset;
      }

      if (document.documentElement.clientHeight - offset <= MIN_BASKET_HEIGHT) {
        basket.style.maxHeight = `${MIN_BASKET_HEIGHT}px`;
      } else {
        basket.style.maxHeight = `calc(100vh - ${offset}px)`;
      }
    }
  };

  // TODO:DN shuuld be in UserDetails component
  private loginAndNavigateTo = (checkout: boolean) => {
    // TODO:DN should use react-router
    let LoginUrl = window.location.hash.substr(1);
    if (checkout) {
      LoginUrl = LoginUrl.replace('restaurant', 'checkout');
    }

    this.props.PushLoginUrl(LoginUrl);

    if (this.props.params.type == 'delivery') {
      Utilities.navigateTo('/phone/' + this.props.params.id);
    } else {
      Utilities.navigateTo('/phone');
    }
  };

  // TODO:DN should be in UserDetails component
  private requestLogIn = () => {
    this.loginAndNavigateTo(false);
  };

  // TODO:DN should be in UserDetails component
  private setSmsEnabled = (state: boolean) => {
    // TODO:DN should be accountServices
    const req = axios.put('/Account/SmsPromotionsEnabledFlag', {
      enabled: state,
    });
    req.then((r) => {
      this.props.SetSmsEnabled(r.data.Data.enabled);
    });
  };

  private collectionLink = (): string => {
    const { AppConfig, CollectionSummaries } = this.props;

    switch (AppConfig.status) {
      case 'success':
        break;
      default:
        return '/collection';
    }

    if (AppConfig.data.DisplayPickupRestaurantListScreen) {
      return '/collection';
    }

    if (CollectionSummaries.status != 'success') {
      return '/collection';
    }

    const [skip] = CollectionSummaries.data.filter(
      (c) => c.SkipToThisPhysicalRestaurant,
    );

    if (!skip) {
      return '/collection';
    }

    return (
      '/restaurant/' +
      skip.VirtualRestaurantId +
      '/collection/' +
      skip.PhysicalRestaurantId
    );
  };

  // TODO:DN should be in UserDetails component
  private handleLogout = () => {
    const {
      AppConfig,
      SetCustomer,
      ShowRestaurantList,
      ClearDeliveryLocations,
    } = this.props;

    SetCustomer({ status: 'pending' });
    const clearCustomer = () => {
      this.props.logoutSuccessBridge();

      this.props.SetCustomer({ status: 'none' });

      cookie.remove('flipdish-token');
      storage.removeItem('flipdish-delivery-locations');
      storage.removeItem('flipdish-location');
      storage.removeItem('flipdish-device-id');

      let link = '/where';

      if (AppConfig.status === 'success' && !AppConfig.data.PickupEnabled) {
        link = '/delivery';
      } else if (
        AppConfig.status === 'success' &&
        !AppConfig.data.DeliveryEnabled
      ) {
        link = this.collectionLink();
      } else if (!ShowRestaurantList) {
        link = '/restaurant/' + this.props.params.vrid;
      }

      Utilities.navigateTo(link);
    };
    axios.post('/Account/LogOff').then(clearCustomer, clearCustomer);
    ClearDeliveryLocations();
  };

  // TODO:DN should be in Basket component
  private handleBasketCheckout = () => {
    const { Restaurant } = this.props;

    switch (Restaurant.status) {
      case 'pending':
      case 'none':
        Raven.captureMessage(
          'Cannot view the basket when the restaurant is not loaded',
        );
        return;
      default:
        break;
    }

    let initialLang = 'en';

    for (const Language of this.props.Languages) {
      if (Language.active) {
        initialLang = Language.code;
        break;
      }
    }

    // Don't start the checkout process unless the user has enough
    // value in the basket.
    const currentBasketTotal = BasketControl.Total(this.props.Basket.items);
    if (currentBasketTotal < Restaurant.data.MinimumOrder) {
      alert(
        this.props.translate('Minimum_order', {
          restaurantName: Restaurant.data.RestaurantName,
          amount: BasketControl.ToCurrency(
            Restaurant.data.MinimumOrder,
            Restaurant.data.Currency,
            initialLang,
          ),
        }),
      );
      return;
    }

    const { Basket } = this.props;

    //Stores if alcohol is in basket
    let alcoholInBasket = false;

    //Check all items in basket for alcohol
    for (const item of Basket.items) {
      if (item.Item.Alcohol) {
        alcoholInBasket = true;
        break;
      }
    }

    const { params, Customer } = this.props;

    const next = alcoholInBasket ? 'over18' : 'checkout';
    let nextUrl = `/${next}/${params.vrid}/${params.type}/${params.id}${
      params.concessionStoreId ? '/' + params.concessionStoreId : ''
    }`;

    if (Customer.status == 'success') {
      Track('Orders', 'Checkout', {
        event_label: Restaurant.data.RestaurantName,
      });

      if (
        !Customer.data.RequireAgeConfirmationForAlcoholOrdersData
          .DisplayConfirmationPrompt
      ) {
        nextUrl = `/checkout/${params.vrid}/${params.type}/${params.id}${
          params.concessionStoreId ? '/' + params.concessionStoreId : ''
        }`;
      }

      Utilities.navigateTo(nextUrl);
    } else {
      // If we are not logged in then show the login box.
      this.loginAndNavigateTo(true);
    }
  };

  private handleClickItem = (payload: {
    menuId: number;
    item: Api.MenuItem;
  }) => {
    const { Restaurant, translate } = this.props;

    switch (Restaurant.status) {
      case 'pending':
      case 'none':
        console.error(
          'Cannot click - restaurant is',
          Restaurant.status,
          this.props,
        );
        return;
      default:
        break;
    }

    if (!Restaurant.data.IsOpen && !Restaurant.data.AcceptPreOrders) {
      const openAt = Utilities.getOpeningTime(Restaurant.data);
      alert(
        translate('Sorry_{restaurantName}_is_closed_It_will_open_at_{openAt}', {
          restaurantName: Restaurant.data.RestaurantName,
          openAt,
        }),
      );
      return;
    }

    const { menuId, item } = payload;
    if (item.MenuItemOptionSets.length == 0) {
      // Add directly to the basket
      this.handleAddItem({ Item: item, Options: [] });

      Track('Restaurants', 'Add Item To Basket Via Menu Directly', {
        event_label: item.Name,
        virtualRestaurantId: this.props.params.vrid,
        name: item.Name,
        itemType: item.MenuItemOptionSets.length == 0 ? 'simple' : 'complex',
        menuId,
      });
      return;
    }

    const { params } = this.props;
    const configureUrl =
      '/restaurant/' +
      params.vrid +
      '/' +
      params.type +
      '/' +
      params.id +
      (params.concessionStoreId ? '/' + params.concessionStoreId : '') +
      '/configure/' +
      item.MenuItemId +
      '/0';
    Utilities.navigateTo(configureUrl);
  };

  private handleAddItem = (payload: BasketControl.Item) => {
    this.props.AddItemToBasket(payload);
  };

  private handleRemoveItem = (payload: {
    menuId: number;
    index: number;
    indexName?: string;
  }) => {
    this.props.AddToast(
      this.props.translate('An_item_was_removed_from_your_basket') as string,
    );
    this.props.RemoveItemFromBasket(payload);

    // TODO inspect what is this??? why would u ever need to 'click' on div
    const node = document.getElementById('flipdish-div');

    if (node) {
      Utilities.fireEvent(node, 'click');
    }
  };

  public render(): JSX.Element {
    const {
      AppConfig,
      Customer,
      ExpandedStates,
      menu,
      Restaurant,
    } = this.props;
    const outsideDeliveryZone: boolean = Routes.OutsideDeliveryZone(Restaurant);

    const isLoaded =
      AppConfig.status == 'success' &&
      Restaurant.status === 'success' &&
      ((menu && !isEmpty(ExpandedStates)) || outsideDeliveryZone);

    let permissionConsentDialog = null;
    if (Customer.status == 'success' && !!Customer.data.EmailAddress) {
      permissionConsentDialog = <PermissionConsentDialog />;
    }

    const sidePanel = (
      <React.Fragment>
        <StatusDisplay
          AppConfig={this.props.AppConfig}
          AppDesignScheme={this.props.AppDesignScheme}
          ChangeLanguage={this.props.ChangeLanguage}
          ContactFormType={this.props.ContactFormType}
          Customer={this.props.Customer}
          Intercom={this.props.Intercom}
          isDark={this.props.isDark}
          Languages={this.props.Languages}
          LogOut={this.handleLogout}
          Params={this.props.params as any}
          RequestLogIn={this.requestLogIn}
          SetCustomerEmail={this.props.SetCustomerEmail}
          SetCustomerName={this.props.setUserName}
          SetSmsEnabled={this.setSmsEnabled}
          translate={this.props.translate}
        />

        <Basket
          AddItem={this.handleAddItem}
          AppDesignScheme={this.props.AppDesignScheme}
          InsideDeliveryZone={!outsideDeliveryZone}
          isDark={this.props.isDark}
          Items={this.props.Basket}
          Languages={this.props.Languages}
          MenuId={menu && menu.MenuId}
          Offset={this.props.Offset}
          OnClick={this.handleBasketCheckout}
          parentComponent={this.props.parentComponent}
          RemoveItemAt={this.handleRemoveItem}
          Restaurant={this.props.Restaurant}
          Screen="restaurant"
          translate={this.props.translate}
          vrid={this.props.params.vrid}
        />
      </React.Fragment>
    );

    return (
      <MainLayout xsPaddingBottom="45px" smPaddingBottom="45px">
        <div className="container-fluid">
          {!isLoaded && (
            <LoadingPanel
              AppDesignScheme={this.props.AppDesignScheme}
              isDark={this.props.isDark}
            />
          )}

          <Toast
            Messages={this.props.ToastMessages}
            AppDesignScheme={this.props.AppDesignScheme}
          />
          <Row>
            <Col lg={12} md={12} sm={12}>
              <LocationHeader
                AppConfig={this.props.AppConfig}
                AppDesignScheme={this.props.AppDesignScheme}
                DeliveryEnabled={this.props.DeliveryEnabled}
                DeliveryLocation={this.props.DeliveryLocation}
                Geo={this.props.Location}
                isDark={this.props.isDark}
                menu={menu}
                params={this.props.params}
                PickupEnabled={this.props.PickupEnabled}
                Restaurant={this.props.Restaurant}
                translate={this.props.translate}
                Type={this.props.params.type}
              />

              <ClosedAlert
                Restaurant={this.props.Restaurant}
                InsideDeliveryZone={!outsideDeliveryZone}
                translate={this.props.translate}
              />
            </Col>
          </Row>

          <Row>
            <Col lg={8} md={8} sm={12}>
              <Menu
                AddItemToBasket={this.handleAddItem}
                AddToExpandedState={this.props.AddToExpandedState}
                AppDesignScheme={this.props.AppDesignScheme}
                Basket={this.props.Basket}
                concessionStoreId={this.props.params.concessionStoreId}
                ExpandedState={this.props.ExpandedState}
                HandleClickItem={this.handleClickItem}
                InitializeExpandedState={this.props.InitializeExpandedState}
                InsideDeliveryZone={!outsideDeliveryZone}
                isDark={this.props.isDark}
                Languages={this.props.Languages}
                menu={menu}
                RemoveFromExpandedState={this.props.RemoveFromExpandedState}
                RemoveItemAt={this.handleRemoveItem}
                Restaurant={this.props.Restaurant}
                translate={this.props.translate}
                vrid={this.props.params.vrid}
              />
            </Col>

            <Col sm={12} md={4} lg={4}>
              {sidePanel}
            </Col>
          </Row>

          <BottomBar
            Restaurant={this.props.Restaurant}
            InsideDeliveryZone={!outsideDeliveryZone}
            OnClick={this.handleBasketCheckout}
            Items={this.props.Basket}
            translate={this.props.translate}
            Languages={this.props.Languages}
            AppDesignScheme={this.props.AppDesignScheme}
          />

          {permissionConsentDialog}
        </div>
      </MainLayout>
    );
  }
}

export default Restaurant;
